export const orderScreenStyle = `
  .order-screen__container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .order-screen__container__header__options {
    display: flex;
    flex-direction: row;
    gap: 1em;
  }
  .order-screen__section-filters {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 1em;
    padding: 1em 2em;
    margin-top: 1em;
    border-bottom: 0.5px solid #dddde9;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 1px -1px 5px 0px rgba(0 0 0 / 10%);
  }
  .order-screen__section-filters_check_enabled {
    flex-direction: column-reverse;
  }
  .order-screen__content-dispatch-action {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 3em;
  }
  .order-screen__check-container {
    display: flex;
    flex-direction: column;
    position: relative;
    cursor: pointer;
    padding-left: 2em;
  }
  .order-screen__check-container input {
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .order-screen__check-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 1.2rem;
    width: 1.2rem;
    background-color: #FFFFFF;
    border: solid 1px #EE7628;
    border-radius: 0.2rem;
  }
  .order-screen__check-container:hover input ~ .order-screen__check-checkmark {
    background-color: #EE7628;
  }
  .order-screen__check-container input:checked ~ .order-screen__check-checkmark {
    background-color: #DA5600;
  }
  .order-screen__check-checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .order-screen__check-container input:checked ~ .order-screen__check-checkmark:after {
    display: block;
  }
  .order-screen__check-container .order-screen__check-checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 12px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
  .order-screen__button-dispatch-action {
    padding: 0.5em 1em;
    border-radius: 1.5rem;
    font-family: "Poppins";
    font-size: 1rem;
    color: #FFFFFF;
    background: linear-gradient(90deg, #EEAB28 -2.99%, #EE7628 16.38%, #DA5600 108.07%);
  }
  .order-screen__button-dispatch-action:hover {
    background: linear-gradient(90deg, #DA5600 -2.99%, #EE7628 16.38%, #EEAB28 108.07%);
  }
  .order-screen__button-dispatch-action:disabled {
    background: #E0E0E0;
  }
  .order-screen__order-list-container {
    width: 100%;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 1px 4px 4px rgb(0 0 0 / 10%);
    padding: 1em;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
  .order-screen__paginate-container {
    width: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  .order-screen__content__header__options {
    display: none;
  }
  .order-screen__content__header__options__item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    gap: 0 0.5em;
    color: #716f87;
  }
  @media screen and (min-width: 768px) {
    .order-screen__section-filters {
      flex-direction: row;
      justify-content: flex-end;
    }
    .order-screen__section-filters_check_enabled {
      flex-direction: row;
      justify-content: space-between;
    }
  }
  @media screen and (min-width: 1280px) {
    .order-screen__content__header__options {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 0 2em;
    }
  }
`